/* eslint-disable */
import React from 'react';

// A designed editorial cover for each Nunba News item. These posts are about
// shipped features and link into our own surfaces, so there is no external
// article to unfurl; a themed cover is the honest way to make the page rich
// with visual media instead of a fabricated screenshot. Each cover is a hive
// motif tinted by the item's category and laid out deterministically from the
// slug, so every card looks distinct but the SVG is identical across the
// prerender and the client (no Math.random, no Date), keeping it hydration
// safe on these prerendered pages.

const THEME = {
  Release:     { a: '#17c07f', b: '#0a7d55' },
  Engineering: { a: '#34d3ff', b: '#0059c9' },
  Community:   { a: '#7c72ff', b: '#4a42a8' },
  Company:     { a: '#ff6b6b', b: '#b23b4a' },
};

// Deterministic PRNG seeded by a string (FNV-1a + mulberry32). Stable output
// for the same slug, so the captured HTML and the hydrated DOM match.
function seeded(str) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
  return function () {
    h += 0x6D2B79F5; let t = h;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function hexPoints(cx, cy, r) {
  const p = [];
  for (let i = 0; i < 6; i++) {
    const a = Math.PI / 6 + (i * Math.PI) / 3;
    p.push(`${(cx + r * Math.cos(a)).toFixed(1)},${(cy + r * Math.sin(a)).toFixed(1)}`);
  }
  return p.join(' ');
}

export default function NewsCover({ category, slug = '', height = 150, label }) {
  const t = THEME[category] || THEME.Community;
  const rnd = seeded(slug || category || 'news');
  const nodes = Array.from({ length: 8 }, function () {
    return { x: 30 + rnd() * 540, y: 12 + rnd() * 126, r: 9 + rnd() * 30, o: (0.12 + rnd() * 0.4).toFixed(2) };
  });
  const gid = `nc-${(slug || category || 'x').replace(/[^a-z0-9]/gi, '')}`;
  return (
    <svg viewBox="0 0 600 150" width="100%" height={height} preserveAspectRatio="xMidYMid slice"
         role="img" aria-label={`${category || 'News'} cover`} style={{ display: 'block' }}>
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor={t.a} />
          <stop offset="1" stopColor={t.b} />
        </linearGradient>
      </defs>
      <rect width="600" height="150" fill={`url(#${gid})`} />
      <rect width="600" height="150" fill="#0b0a12" opacity="0.32" />
      {nodes.map(function (n, i) {
        return (
          <polygon key={i} points={hexPoints(n.x, n.y, n.r)} fill="none"
                   stroke="#ffffff" strokeWidth="1.3" opacity={n.o} />
        );
      })}
      <text x="26" y="132" fill="#ffffff" opacity="0.92" fontFamily="ui-monospace, monospace"
            fontSize="12" letterSpacing="2.5" fontWeight="700">
        {(label || category || 'NEWS').toUpperCase()}
      </text>
      <circle cx="564" cy="26" r="5.5" fill="#ffffff" opacity="0.85" />
      <circle cx="550" cy="26" r="2.5" fill="#ffffff" opacity="0.5" />
    </svg>
  );
}
